var render = function () {
  var _vm$lecture, _vm$lecture2, _vm$lecture2$meta, _vm$lecture2$meta$wat, _vm$lecture2$meta$wat2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    ref: "info-card",
    attrs: {
      "outlined": ""
    }
  }, [_vm._t("default"), _c('v-divider'), _c('v-card-text', [_c('v-row', {
    staticClass: "mx-n4 mt-n4 mb-0",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pa-4 font-size-18 font-weight-bold text-truncate"
  }, [_vm._v(" " + _vm._s((_vm$lecture = _vm.lecture) === null || _vm$lecture === void 0 ? void 0 : _vm$lecture.subject) + " ")]), _c('v-col', {
    staticClass: "pa-4",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-chip', {
    attrs: {
      "small": "",
      "outlined": ""
    }
  }, [_vm._v(_vm._s((_vm$lecture2 = _vm.lecture) === null || _vm$lecture2 === void 0 ? void 0 : (_vm$lecture2$meta = _vm$lecture2.meta) === null || _vm$lecture2$meta === void 0 ? void 0 : (_vm$lecture2$meta$wat = _vm$lecture2$meta.watcherCount) === null || _vm$lecture2$meta$wat === void 0 ? void 0 : (_vm$lecture2$meta$wat2 = _vm$lecture2$meta$wat.format) === null || _vm$lecture2$meta$wat2 === void 0 ? void 0 : _vm$lecture2$meta$wat2.call(_vm$lecture2$meta$wat)) + "명 참여")])], 1)], 1), _vm.isUserCompany ? _c('v-row', {
    staticClass: "mx-n4 mt-0 mb-n4",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "px-4 pt-0 pb-4 font-size-14",
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('info-link')], 1), _c('v-col', {
    staticClass: "px-4 pt-0 pb-4 font-size-14",
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('info-code')], 1)], 1) : _vm._e()], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }